import { render } from "./ShopNow.vue?vue&type=template&id=5cd6b09f"
import script from "./ShopNow.vue?vue&type=script&lang=js"
export * from "./ShopNow.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/dindin.mombaby.kroutony.me/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__